import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { ListItem, List } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

// import Tabs from '@mui/material/Tabs';
// import Tab from '@mui/material/Tab';
import Checkbox from '@material-ui/core/Checkbox';
import { mainPimColor } from '../PimTogoTheme';
import TextField from '@mui/material/TextField';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

const useStyles_ = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    position: 'relative',
    overflow: 'auto',
    maxHeight: 255
  },
  root_: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    position: 'relative',
    overflow: 'auto',
    maxHeight: 255
  },
  listSection: {
    backgroundColor: 'inherit'
  },
  ul: {
    backgroundColor: 'inherit',
    padding: 0
  },
  checkboxStyle: {
    '&.Mui-checked': {
      color: mainPimColor
    }
  },
  tabs: {
    '& .MuiTabs-indicator': {
      backgroundColor: mainPimColor,
      height: 5,
      top: 43
    },
    '& .MuiTab-textColorPrimary.Mui-selected': {
      opacity: 1,
      fontWeight: 'bold',
      color: 'black',
      fontSize: '13px'
    }
  },
  tabPanel: {
    padding: 0,
    '& > div': {
      padding: 0
    }
  }
}));

export default function FacetBox({
  filter,
  setFilter,
  updateSearch,
  facetElement,
  allSearchIds,
  changeAllSearchIds,
  deleteFilterValue,
  checked,
  setChecked,
  isFacetValueChecked
}) {
  const classes = useStyles_();
  // const [value, setValue] = React.useState(0);
  const { t } = useTranslation();

  const [
    searchTermForValuesInFacet,
    setSearchTermForValuesInFacet
  ] = React.useState('');

  // const handleChangeTabs = (event, newValue) => {
  //   setValue(newValue);
  // };

  useEffect(() => {
    setSearchTermForValuesInFacet('');
  }, [facetElement]);

  const handleSearchChange = (event) => {
    setSearchTermForValuesInFacet(event.target.value.toLowerCase());
  };

  const searchValuesinFacet = (values) => {
    return values.filter((value) =>
      value?.valueLabel?.toLowerCase().includes(searchTermForValuesInFacet)
    );
  };

  const handleToggle = (value) => () => {
    const currentIndex = checked.findIndex(
      (item) =>
        item?.searchIds[0] == value?.searchIds[0] &&
        value?.valueAsString == item?.valueAsString
    );

    const allSearchIdsIndex = allSearchIds.indexOf(value?.searchIds[0]);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      const valueWithLabel = { ...value };
      valueWithLabel.facetLabel = facetElement?.label;
      newChecked.push(valueWithLabel);

      if (allSearchIdsIndex === -1) {
        changeAllSearchIds(value?.searchIds[0], true);
        addFilterValue(value, true);
      } else {
        addFilterValue(value, false);
      }
    } else {
      newChecked.splice(currentIndex, 1);
      deleteFilterValue(value, false);
    }
    setChecked(newChecked);
  };

  const addFilterValue = (item, bool) => {
    if (bool) {
      var textSearchFilter = new Object();
      textSearchFilter.allSearchIds = item.searchIds;
      textSearchFilter.values = [];

      var TextSearchFilterValue = new Object();
      TextSearchFilterValue.value = item?.valueAsString;
      TextSearchFilterValue.valueSearchIds = item.searchIds;
      textSearchFilter.values.push(TextSearchFilterValue);

      if (
        textSearchFilter.allSearchIds.some(
          (id) => id.startsWith('feature_') || id.startsWith('customField_')
        ) &&
        facetElement?.uniqueRootField == 'productRootIstance'
      ) {
        textSearchFilter.filterParentforChildren = true;
      } else {
        textSearchFilter.filterParentforChildren = false;
      }

      filter.push(textSearchFilter);
      setFilter(filter);

      updateSearch(filter);
    } else {
      filter?.map((textSearchFilter) => {
        if (textSearchFilter?.allSearchIds[0] === item?.searchIds[0]) {
          var textSearchFilterValue = new Object();
          textSearchFilterValue.value = item?.valueAsString;
          textSearchFilterValue.valueSearchIds = item.searchIds;
          textSearchFilter.values.push(textSearchFilterValue);

          if (textSearchFilter?.allSearchIds[0].indexOf('feature_') != -1) {
            textSearchFilterValue.filterParentforChildren = true;
          } else {
            textSearchFilterValue.filterParentforChildren = false;
          }
        }
      });
      setFilter(filter);
      updateSearch(filter);
    }
  };

  if (!facetElement) {
    return <></>;
  }

  return (
    <>
      <TextField
        sx={{ marginLeft: '1.5rem', width: '90%' }}
        label={t('common.search')}
        variant="outlined"
        size="small"
        margin="dense"
        value={searchTermForValuesInFacet}
        onChange={handleSearchChange}
      />
      {facetElement.valueGroups ? (
        facetElement?.valueGroups?.map((valueGroup, idx) => (
          <TabPanel
            value={0}
            key={idx}
            index={idx}
            className={classes.tabPanel}
          >
            <List className={classes.root_}>
              {valueGroup?.values != undefined &&
                searchValuesinFacet(valueGroup?.values)?.map((value, index) => {
                  const labelId = `checkbox-list-label-${value?.valueLabel}`;
                  return (
                    <ListItem
                      key={index}
                      role={undefined}
                      dense
                      button
                      onClick={handleToggle(value)}
                    >
                      <ListItemIcon>
                        <Checkbox
                          edge="start"
                          checked={isFacetValueChecked(checked, value)}
                          tabIndex={-1}
                          disableRipple
                          inputProps={{ 'aria-labelledby': labelId }}
                          className={classes.checkboxStyle}
                        />
                      </ListItemIcon>
                      <ListItemText
                        id={labelId}
                        primary={
                          <Typography fontSize={12}>
                            {value.valueLabel + ' (' + value.valueCount + ')'}{' '}
                          </Typography>
                        }
                      />
                    </ListItem>
                  );
                })}
            </List>
          </TabPanel>
        ))
      ) : (
        <List className={classes.root}>
          {facetElement.values != undefined &&
            searchValuesinFacet(facetElement?.values)?.map((value, index) => {
              const labelId = `checkbox-list-label-${value}`;
              return (
                <ListItem
                  key={index}
                  role={undefined}
                  dense
                  button
                  onClick={handleToggle(value)}
                >
                  <ListItemIcon>
                    <Checkbox
                      edge="start"
                      checked={isFacetValueChecked(checked, value)}
                      tabIndex={-1}
                      disableRipple
                      inputProps={{ 'aria-labelledby': labelId }}
                      className={classes.checkboxStyle}
                    />
                  </ListItemIcon>
                  <ListItemText
                    id={labelId}
                    primary={
                      <Typography fontSize={12}>
                        {value.valueLabel + ' (' + value.valueCount + ')'}{' '}
                      </Typography>
                    }
                  />
                </ListItem>
              );
            })}
        </List>
      )}
    </>
  );
}
